<template>
  <!-- Banner -->
  <DjBanner
    v-if="header?.showtopbar"
    :banner-link="header?.topbarlink?.url"
    banner-class="w-full py-2 px-4 flex justify-center items-center"
  >
    <template #message>
      <span class="text-black text-sm leading-none">{{ header?.topbartext }}</span>
    </template>
  </DjBanner>
  <header class="sticky top-0 z-10 bg-white">
    <DjHeaderMain :user-avatar-url="userAvatarUrl" />
    <DjHeaderBottom :email="email" :phone="phone" :name="nameAdv" />
  </header>
</template>

<script lang="ts" setup>
  // Define Options
  defineOptions({
    name: 'DjHeader',
  });
  const useStore = useUserStore();
  const storyblokStore = useStoryblokStore();
  const { switchCustomerAccount } = useAccount();
  const { t } = useI18n();
  const userStoreSelected = computed(() => useStore.store);
  const currentStore = ref(userStoreSelected.value);
  // Composables and Stores

  // Fetch Header Data from Storyblok (SSR)
  const { data: header } = await useAsyncData(() =>
    storyblokStore.fetchStory('header').then(() => storyblokStore.getStoryByName('header'))
  );

  const userAvatarUrl = computed(() => header.value?.userAvatar);

  const isAuthenticated = computed(() => useStore.isAuthenticated);
  // Conditional Values for Header Bottom
  const email = computed(() => header.value?.email);
  const phone = computed(() => header.value?.phone);
  const nameAdv = computed(() => header.value?.name);

  async function changeStore(value: any) {
    switchCustomerAccount({ storeId: value?.STORE_ID, storeViewId: value?.STORE_VIEW_ID });
    if (window.location.pathname === '/') {
      location.reload();
    } else {
      window.location.href = '/';
    }
  }
  watch([currentStore], () => {
    changeStore(currentStore.value);
  });
</script>

<style scoped lang="scss">
  .dj-block--user-account {
    position: relative;
    i {
      font-size: 30px;
      line-height: 1em;
    }
    .dj-list--arrow {
      li {
        cursor: pointer;
        padding: 10px;
        a {
          padding-left: 0;
          &:before {
            display: none;
          }
        }
      }
    }

    .dj-block__content {
      background-color: #fff;
      position: absolute;
      min-width: 240px;
      right: 0;
      z-index: 30;
      padding-top: 10px;
      transform: translate(0 0);
      transition: all 0.4s ease;
      visibility: hidden;
      &.order-types {
        min-width: 140px;
      }
    }
    &:hover {
      i {
        cursor: pointer;
      }
      .dj-block__content {
        visibility: visible;
        transform: translate(0 20px) scale3d(1, 1, 1);
        padding: 10px 15px;
      }
    }
  }
</style>
